const env = process.env;

/** Public web-app identifiers from the Firebase console (Project settings > General > Your apps > Web). */
export const webFirebaseConfig = {
  apiKey: env.REACT_APP_FIREBASE_API_KEY,
  authDomain: env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: env.REACT_APP_FIREBASE_PROJECT_ID,
  messagingSenderId: env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.REACT_APP_FIREBASE_APP_ID,
};

/** Web push certificate key pair (Project settings > Cloud Messaging > Web configuration). */
export const webVapidKey = env.REACT_APP_FIREBASE_VAPID_KEY;

export const isWebPushConfigured = () =>
  Boolean(
    webFirebaseConfig.apiKey &&
      webFirebaseConfig.projectId &&
      webFirebaseConfig.messagingSenderId &&
      webFirebaseConfig.appId &&
      webVapidKey
  );

export const SERVICE_WORKER_URL = "/firebase-messaging-sw.js";

/** Identifies messages from public/firebase-messaging-sw.js; keep in step with that file. */
export const SERVICE_WORKER_SOURCE = "kothar-push";

/** Must match the channel id the backend sets on Android pushes. */
export const ANDROID_CHANNEL_ID = "kothar_default";
